import { render, staticRenderFns } from "./VideoTableRowMenu.vue?vue&type=template&id=824b90a2"
import script from "./VideoTableRowMenu.vue?vue&type=script&lang=js"
export * from "./VideoTableRowMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports